// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"VO-z","loadingMedia":"WO-z","reviewsImagesAndVideos":"XO-z","limitHeight":"YO-z"};